module.exports = __webpack_public_path__ + "media/lipoma.e8e3ce5a.wav";